export interface ProfileTrip {
  id: string;
  title: string;
  meta: string;
  imageUrl: string;
  description: string;
}

export const profileTrips: ProfileTrip[] = [
  {
    id: 'santorini-escape',
    title: 'Santorini Escape',
    meta: 'Jun 2026 · 5 days',
    imageUrl: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?auto=format&fit=crop&w=700&q=80',
    description: 'Blue domes, cliffside sunsets, and slow mornings around Oia.',
  },
  {
    id: 'bali-adventure',
    title: 'Bali Adventure',
    meta: 'Mar 2026 · 7 days',
    imageUrl: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=700&q=80',
    description: 'Rice terraces, surf mornings, temples, and Ubud food stops.',
  },
  {
    id: 'tokyo-lights',
    title: 'Tokyo Lights',
    meta: 'Jan 2026 · 5 days',
    imageUrl: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=700&q=80',
    description: 'Neon nights, tiny ramen bars, galleries, and day trips.',
  },
  {
    id: 'paris-weekend',
    title: 'Paris Weekend',
    meta: 'Nov 2025 · 4 days',
    imageUrl: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=700&q=80',
    description: 'Cafes, museums, markets, and a relaxed Seine-side route.',
  },
  {
    id: 'coastal-portugal',
    title: 'Coastal Portugal',
    meta: 'Sep 2025 · 6 days',
    imageUrl: 'https://images.unsplash.com/photo-1500375592092-40eb2168fd21?auto=format&fit=crop&w=700&q=80',
    description: 'Lisbon, Sintra, Porto, and Atlantic viewpoints.',
  },
  {
    id: 'greek-islands',
    title: 'Greek Islands',
    meta: 'Jul 2025 · 8 days',
    imageUrl: 'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?auto=format&fit=crop&w=700&q=80',
    description: 'A slow island route with ferries, beaches, and tavernas.',
  },
  {
    id: 'iceland-ring-road',
    title: 'Iceland Ring Road',
    meta: 'May 2025 · 9 days',
    imageUrl: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=700&q=80',
    description: 'Waterfalls, black sand beaches, glacier hikes, and long scenic drives.',
  },
  {
    id: 'morocco-colors',
    title: 'Morocco Colors',
    meta: 'Apr 2025 · 6 days',
    imageUrl: 'https://images.unsplash.com/photo-1539020140153-e8c237112e53?auto=format&fit=crop&w=700&q=80',
    description: 'Markets, riads, desert edges, and colorful food-first city days.',
  },
  {
    id: 'new-york-food',
    title: 'New York Food',
    meta: 'Feb 2025 · 4 days',
    imageUrl: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?auto=format&fit=crop&w=700&q=80',
    description: 'A weekend built around bakeries, ramen, galleries, and neighborhood walks.',
  },
  {
    id: 'costa-rica-wild',
    title: 'Costa Rica Wild',
    meta: 'Jan 2025 · 7 days',
    imageUrl: 'https://images.unsplash.com/photo-1518182170546-07661fd94144?auto=format&fit=crop&w=700&q=80',
    description: 'Rainforest trails, beaches, wildlife, and slow nature days.',
  },
];
